module.exports = __webpack_public_path__ + "assets/img_soomsoom.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_soomsoom.jpg
 ** module id = 133
 ** module chunks = 1
 **/